import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import pluralize from 'pluralize';

import Button from 'components/Button';
import Icon from 'components/Icon';

import Screen from 'components/Screen';
import { getTrackUrlFilters } from 'helpers/url';
import useToggle from 'hooks/useToggle';

import ConfirmationActionMenu from 'components/ActionMenu/ActionMenus/ConfirmationActionMenu';
import closeIcon from 'images/icon-close.svg';

const DesktopWrapper = styled.div`
  align-items: center;
  display: flex;
  margin-left: 1.5rem;
`;

const MobileWrapper = styled.div`
  align-items: center;
  background: ${({ active }) => (active ? '#CCCCCC' : 'transparent')};
  border-radius: 100px;
  cursor: pointer;
  display: flex;
  flex: 1 0 auto;
  height: 3.7rem;
  margin-left: 0.5rem;
  justify-content: center;
  text-align: center;
  width: 3.7rem;
`;

const UrlTableFilters = ({ location, history }) => {
  // TODO: Refactor this to support different filters as needed.
  const { labelIds } = getTrackUrlFilters(location);
  const filterQuantity = labelIds.length;

  const clearFilters = () => history.push(location.pathname);

  const { open, close, isOpen } = useToggle();

  if (filterQuantity === 0) return null;

  return (
    <>
      <Screen.MEDIUM up>
        <DesktopWrapper>
          <Button
            color={Button.COLORS.NEUTRAL}
            onClick={clearFilters}
            data-testid="Table-clear-filters-btn"
            expand
            rounded
          >
            <span data-testid="Table-filter-description">
              {filterQuantity} {pluralize('Label', filterQuantity)}
            </span>{' '}
            <img
              src={closeIcon}
              width="10"
              height="10"
              style={{ marginLeft: '0.5rem' }}
              alt="X Icon"
            />
          </Button>
        </DesktopWrapper>
      </Screen.MEDIUM>

      <Screen.MEDIUM down>
        <ConfirmationActionMenu
          isOpen={isOpen}
          close={close}
          message={`You are filtering tracks by ${filterQuantity} labels, would you like to clear them?`}
          confirmText="Clear Filters"
          // onConfirm must be a promise if using handleConfirm prop
          onConfirm={() =>
            new Promise(resolve => {
              clearFilters();
              resolve();
            })
          }
          handleConfirm
        />
        <MobileWrapper active={filterQuantity > 0} onClick={open}>
          <Icon
            type={Icon.TYPES.FILTER}
            color={filterQuantity > 0 ? Icon.COLORS.WHITE : Icon.COLORS.LIGHT}
            width={20}
          />
        </MobileWrapper>
      </Screen.MEDIUM>
    </>
  );
};

UrlTableFilters.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
    pathname: PropTypes.string
  }),
  history: PropTypes.shape({
    push: PropTypes.func
  })
};

export default withRouter(UrlTableFilters);
